// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3iGAz","selected":"Chip_selected__2bhMM"};